import { cn } from '@servicetim/ui/lib';

/** Read-only, scrollable JSON block. */
export function JsonView({ value, className }: { value: unknown; className?: string }) {
  return (
    <pre
      className={cn(
        'max-h-[60vh] overflow-auto rounded-md border border-border bg-surface-sunken p-3 font-mono text-xs leading-relaxed',
        className,
      )}
    >
      {JSON.stringify(value, null, 2)}
    </pre>
  );
}
